import { searchLocation } from "apis";
import { FilterBar, FilterMultiSelect } from "components";
import { useApi, useMount } from "hooks";
import { allLocationRequest, location } from "mappers";
import React, { useCallback, useMemo } from "react";
import { mapObject, mapObjectsToSelect, sortByKeyName } from "services";
import lang from "translations";
import { roleOptions } from "../staff-form/staff-form-state";
import { StaffStatus } from "enums";

const inviteOptions = [
  {
    text: lang.awaiting,
    value: StaffStatus.Awaiting,
  },
  {
    text: lang.accepted,
    value: StaffStatus.Active,
  },
];

const StaffFilter = ({ filterState, requestState, modifyFilter, clearFilter, applyFilter }) => {
  const {
    request: searchLocationRequest,
    loading: loadingLocations,
    mappedData: locations,
  } = useApi({
    api: searchLocation,
    isArray: true,
    mapper: location,
    handleOwnError: true,
  });

  useMount(() => {
    fetchLocationRequest(requestState);
  });

  const fetchLocationRequest = useCallback(
    (requestState) => {
      searchLocationRequest(mapObject({ ...requestState }, allLocationRequest));
    },
    [searchLocationRequest]
  );

  const locationOptions = useMemo(() => {
    let sorted = locations
      .map((item) => {
        item.name = item.name.trim();
        return item;
      })
      .sort((a, b) => (a.name > b.name ? 1 : -1));

    return mapObjectsToSelect(sorted, { textKey: "name" });
  }, [locations]);
  return (
    <FilterBar
      placeholder={lang.searchStaffEmailOrTagID}
      className="mb-lg"
      onClear={clearFilter}
      onApply={applyFilter}
      filterState={filterState}
    >
      <FilterMultiSelect
        id="roles"
        label={lang.role}
        allLabel={lang.allRoles}
        options={roleOptions(true).sort(sortByKeyName("text"))}
        value={filterState.roles}
        onChange={(value) => modifyFilter("roles", { value })}
      />
      <FilterMultiSelect
        id="locations"
        label={lang.outlet}
        allLabel={lang.allLocations}
        emptyLabel={lang.noLocationAvailable}
        disableWhenEmpty={false}
        loading={loadingLocations}
        options={locationOptions}
        value={filterState.locations}
        onChange={(value) => modifyFilter("locations", { value })}
      />
      <FilterMultiSelect
        id="invites"
        label={lang.inviteResponse}
        allLabel={lang.allResponse}
        options={inviteOptions}
        value={filterState.invites}
        onChange={(value) => modifyFilter("invites", { value })}
      />
    </FilterBar>
  );
};

export default StaffFilter;
